import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from '@hazmatsuite-next/ui';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { EnumPackageType } from '../../../models/package-type.enum';
import { CompositePackagingModel } from '../../../models/composite-packaging.model';
import { Packages } from '../../../models/packages.interface';
import { OverPackagingModel } from '../../../models/over-packaging.model';

@Component({
  selector: 'lib-easydgd-composite-packaging-item',
  templateUrl: './composite-packaging-item.component.html',
  styleUrls: ['./composite-packaging-item.component.scss'],
})
export class CompositePackagingItemComponent {
  @Input() item!: CompositePackagingModel;
  @Input() isLast = false;
  @Input() showPrintLabel = false;
  @Input() overpackItems: OverPackagingModel[] = [];

  @Output() editPackage = new EventEmitter<CompositePackagingModel>();
  @Output() duplicateCompositePackage = new EventEmitter<CompositePackagingModel>();
  @Output() removeCompositePackage = new EventEmitter<CompositePackagingModel>();
  @Output() assignOverpack = new EventEmitter<{ packageId: string, overpackId: string }>();
  @Output() editOverpackItem = new EventEmitter<{ packageId: string, pkg: OverPackagingModel, isEdit: boolean }>();

  packageTypes = EnumPackageType;
  collapsed = false;
  showOverpackModal = false;

  public packingListResource$: Observable<any> = this.languageService.translations$.pipe(
    map(translations => translations['PackingListResource']));

  constructor(private languageService: LanguageService, private store: Store<{ packageList: { packages: Packages } }>) { }

  edit(): void {
    this.editPackage.emit(this.item);
  }

  copyPackage(): void {
    this.duplicateCompositePackage.emit(this.item);
  }

  removePackage(): void {
    this.removeCompositePackage.emit(this.item);
  }

  chooseOverpack(): void {
    this.showOverpackModal = true;
  }

  toggleContent(): void {
    this.collapsed = !this.collapsed;
  }

  editOverpack(data: { packageId: string, pkg: OverPackagingModel, isEdit: boolean }) {
    this.editOverpackItem.emit(data);
  }

  selectOverpack(id: string): void {
    this.assignOverpack.emit({ packageId: this.item.Id, overpackId: id });
  }
}
